<template>
  <!-- <div class="bg-container page">
    <img class="bg-img" src="img/login/login-bg.png">
    <div class="bg-wrapper">
      <div class="register">
        <van-nav-bar class="nav-bar">
          <template #left>
            <van-icon name="arrow-left" color="#fff" @click="back()"/>
          </template>
</van-nav-bar>
<div class="wrapper">
  <div class="logo-container">
    <div class="logo-wrapper">
      <img class="logo-img"
        :src="this.$store.getters.getBaseInfo.ico !==undefined ?this.$store.getters.getBaseInfo.ico:''">
    </div>
  </div>
  <div class="title">{{$t("auth.register")}}</div>
  <div class="loginForm">
    <van-field v-model="username" clearable input-align="center" class="input"
      :placeholder="$t('auth.username_place')" />
    <van-field v-model="password" :type="passwordType" input-align="center" class="input"
      :placeholder="$t('auth.pwd_place')">
      <template slot="right-icon">
                <van-icon :name=" passwordType === 'password' ? 'closed-eye':'eye-o'" @click="switchPasswordType"/>
              </template>
    </van-field>
    <van-field v-model="code" clearable input-align="center" class="input"
      :placeholder="$t('auth.invite_code_place')" />
    <div class="agreement">
      <van-checkbox v-model="checked" />
      <span class="agreement-text">{{$t("auth.agreement_place")}}</span>
    </div>
    <van-button class="login-btn" type="primary" size="normal"
      @click="doRegister()">{{$t("auth.register")}}</van-button>
  </div>
</div>
</div>
</div>
</div> -->

  <div class="register-container">
    <div class="header">
      <img src="@/assets/更多.png" alt="">
      <!-- <img class="logo" src="@/assets/login.jpg" alt=""> -->
      <div @click="toLogin">
        <span>{{ $t('auth.login') }}</span>
      </div>
    </div>

    <p class="title">{{ $t('auth.register') }}</p>

    <form @submit.prevent="register">
      <div class="form-group">
        <div class="sexual-options">
          <label>{{ $t('auth.me') }}</label>
          <div class="sex">
            <div class="sex-option" :class="{ 'selected-male': sex === 'male' }" @click="selectMysex('male')">
              <svg t="1742283475920" class="icon" viewBox="0 0 1024 1024" version="1.1"
                xmlns="http://www.w3.org/2000/svg" p-id="5308" data-darkreader-inline-fill="" width="52" height="52">
                <path
                  d="M437 237.8c-49.9 0-90.1 41.3-90.1 92.8v219.6c0 42.7 61.6 42.7 61.6 0V349.4H423v556.5c0 57.1 82 55.4 82 0V580.1h14.1v325.8c0 55.4 82.5 57.1 82.5 0V349.4H616v200.8c0 43 61.3 43 61.2 0V332c0-47.5-36.4-94.1-91.2-94.1l-149-0.1zM511.8 217.8c39.2 0 71-31.8 71-71s-31.8-71-71-71-71 31.8-71 71c0 39.3 31.8 71 71 71z"
                  fill="#111111" p-id="5309" data-darkreader-inline-fill=""
                  style="--darkreader-inline-fill: var(--darkreader-background-111111, #0d0e0e);">
                </path>
              </svg>
            </div>
            <div class="sex-option" :class="{ 'selected-female': sex === 'female' }"
              @click="selectMysex('female')">
              <svg t="1742283725070" class="icon" viewBox="0 0 1024 1024" version="1.1"
                xmlns="http://www.w3.org/2000/svg" p-id="1714" data-darkreader-inline-fill="" width="52" height="52">
                <path
                  d="M512.5 214c39.6 0 71.7-32.1 71.7-71.7s-32.1-71.7-71.7-71.7-71.7 32.1-71.7 71.7 32.1 71.7 71.7 71.7zM501.9 668.7v250.8c0 45.1-67.6 45.1-67.6 0V668.7h-89.6l95.9-332.6h-15.1l-56.5 190c-13.4 41.4-70.3 24.4-57.3-20l62.7-206.4c6.7-23.5 36.5-65.3 88-65.3H561c51.1 0 81 42.1 88.7 65.3l62.7 206.2c12.5 44.3-43.9 62.7-57.3 19.5l-56.4-189.3h-16.3l96.9 332.6h-90v251.2c0 44.8-67.3 44.6-67.3 0V668.7h-20.1z"
                  fill="#212121" p-id="1715" data-darkreader-inline-fill=""
                  style="--darkreader-inline-fill: var(--darkreader-background-212121, #191b1c);">
                </path>
              </svg>
            </div>
          </div>
        </div>
        <div class="sexual-options">
          <label>{{ $t('auth.you') }}</label>
          <div class="sex">
            <div class="sex-option" :class="{ 'selected-male': Tosex === 'male' }"
              @click="selectTosex('male')">
              <svg t="1742283475920" class="icon icon-male" viewBox="0 0 1024 1024" version="1.1"
                xmlns="http://www.w3.org/2000/svg" p-id="5308" data-darkreader-inline-fill="" width="52" height="52">
                <path
                  d="M437 237.8c-49.9 0-90.1 41.3-90.1 92.8v219.6c0 42.7 61.6 42.7 61.6 0V349.4H423v556.5c0 57.1 82 55.4 82 0V580.1h14.1v325.8c0 55.4 82.5 57.1 82.5 0V349.4H616v200.8c0 43 61.3 43 61.2 0V332c0-47.5-36.4-94.1-91.2-94.1l-149-0.1zM511.8 217.8c39.2 0 71-31.8 71-71s-31.8-71-71-71-71 31.8-71 71c0 39.3 31.8 71 71 71z"
                  fill="#111111" p-id="5309" data-darkreader-inline-fill=""
                  style="--darkreader-inline-fill: var(--darkreader-background-111111, #0d0e0e);">
                </path>
              </svg>
            </div>
            <div class="sex-option" :class="{ 'selected-female': Tosex === 'female' }"
              @click="selectTosex('female')">
              <svg t="1742283725070" class="icon icon-male" viewBox="0 0 1024 1024" version="1.1"
                xmlns="http://www.w3.org/2000/svg" p-id="1714" data-darkreader-inline-fill="" width="52" height="52">
                <path
                  d="M512.5 214c39.6 0 71.7-32.1 71.7-71.7s-32.1-71.7-71.7-71.7-71.7 32.1-71.7 71.7 32.1 71.7 71.7 71.7zM501.9 668.7v250.8c0 45.1-67.6 45.1-67.6 0V668.7h-89.6l95.9-332.6h-15.1l-56.5 190c-13.4 41.4-70.3 24.4-57.3-20l62.7-206.4c6.7-23.5 36.5-65.3 88-65.3H561c51.1 0 81 42.1 88.7 65.3l62.7 206.2c12.5 44.3-43.9 62.7-57.3 19.5l-56.4-189.3h-16.3l96.9 332.6h-90v251.2c0 44.8-67.3 44.6-67.3 0V668.7h-20.1z"
                  fill="#212121" p-id="1715" data-darkreader-inline-fill=""
                  style="--darkreader-inline-fill: var(--darkreader-background-212121, #191b1c);">
                </path>
              </svg>
            </div>
          </div>
        </div>
      </div>

      <div class="form-group">
        <label>{{ $t('auth.nickname') }}</label>
        <input type="text" v-model="name" required :placeholder="$t('auth.nickname')">
      </div>

      <div class="form-group">
        <label>{{ $t('auth.age') }}</label>
        <select v-model="age" required>
          <option v-for="age in ages" :key="age" :value="age">{{ age }}</option>
        </select>
      </div>

      <div class="form-group">
        <label>{{ $t('auth.username_place') }}</label>
        <input type="text" v-model="username" required :placeholder="$t('auth.username_place')">
      </div>

      <div class="form-group">
        <label>{{ $t('auth.pwd_place') }}</label>
        <input type="password" v-model="password" required :placeholder="$t('auth.pwd_place')" pattern=".{8,}">
        <span v-if="password && password.length < 8" class="error-message">{{ $t('auth.pw_length_error') }}</span>
      </div>

      <div class="form-group">
        <label>{{ $t('auth.invite_code_place') }}</label>
        <input type="text" v-model="code" required :placeholder="$t('auth.invite_code_place')">
      </div>

      <div class="form-group checkbox">
        <input type="checkbox" id="terms" v-model="terms" required>
        <div class="tiaokuan">
          <label for="terms">{{ $t("auth.register_protocol") }}</label>
        </div>
      </div>

      <button type="submit">{{ $t("auth.register") }}</button>

      <!-- <img class="anquan" src="https://cdn.ywxi.net/meter/vietnamcupid.com/211.svg?ts=1741790051933&l=zh" alt=""> -->
    </form>
  </div>
</template>

<script>
export default {
  model: {
    prop: 'inputValue',
    event: 'input'
  },
  props: {
    /**
     * 当前输入的值
     */
    inputValue: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      checked: true,
      username: '',
      code: '',
      lang: 'en_us',
      password: this.inputValue,
      passwordType: 'password',
      sex: '',
      name: '',
      age: '',
      ages: Array.from({ length: 61 }, (_, i) => i + 19),
      email: '',
      terms: false,
      Tosex: ''
    };
  },
  mounted() {
    this.lang = localStorage.getItem("lang") || 'es_spa';
  },
  methods: {
    toLogin() {
      this.$router.push("Login");
    },
    // 选择改变性别
    selectMysex(selectedsex) {
      this.sex = selectedsex;
      this.Tosex = selectedsex === 'male' ? 'female' : 'male';
    },
    // 选择改变我想找的性别
    selectTosex(selectedsex) {
      this.Tosex = selectedsex;
    },
    async register() {
      try {
        console.log(this.doRegister())
      } catch (error) {
        console.error('注册失败:', error);
        alert('注册失败，请重试。');
      }
    },
    switchPasswordType() {
      this.passwordType = this.passwordType === 'password' ? 'text' : 'password'
    },
    back() {
      return window.history.back();
    },
    doRegister() {
      if (this.username === "" || this.username === null || this.username === undefined) {
        this.$toast.fail(this.$t("auth.username_place"));
        return false;
      }
      if (this.password === "" || this.password === null || this.password === undefined) {
        this.$toast.fail(this.$t("auth.pwd_place"));
        return false;
      }
      if (this.code === "" || this.code === null || this.code === undefined) {
        this.$toast.fail(this.$t("auth.invite_code_place"));
        return false;
      }
      if (!this.checked) {
        this.$toast.fail(this.$t("auth.agreement"));
        return false;
      }
      this.$http({
        method: 'post',
        data: {
          username: this.username,
          password: this.password,
          code: this.code,
          lang: this.lang,
          sex: this.sex,
          to_sex: this.Tosex
        },
        url: 'member_register'
      }).then(res => {
        if (res.code === 200) {
          this.$toast.success(res.msg);
          localStorage.setItem('token', res.data)
          this.$router.push("Mine")
        } else {
          // if(res.msg === "Mã Mời Không Tồn Tại！"){
          //      this.$customModal.confirm({
          //       title: this.$t("auth.tctitle"), //标题
          //       okTg: this.$t("auth.tctg"), //类型
          //       content: this.$t("auth.tccontent"), //内容
          //       okText: "",
          //       cancelText: "",      
          //     });
          // }

          this.$toast.fail(res.msg);
        }
      })
    }
  },
  created() {
    if (localStorage.getItem('token')) {
      return window.history.back();
    }
  }
};
</script>

<style lang='less' scoped>
@import "~@/common/index.less";
</style>
